import { createApi } from "@reduxjs/toolkit/query/react";

import apiBaseQuery from "./esgBaseQuery";

export const BASE_METRICS_API_REDUCER_KEY = "esg-moduleApi";

export const esgmoduleactivites = createApi({
  reducerPath: BASE_METRICS_API_REDUCER_KEY,
  baseQuery: apiBaseQuery,
  tagTypes: ["esg-module"],
  endpoints: (builder) => ({
    getBaseMetricsList: builder.query({
      query: () => {
        return {
          url: `/v1/metric-master`,
          method: "GET",
        };
      },
      providesTags: ["esg-module"],
    }),

    getdashboardList: builder.query({
      query: ({ start, end }) => ({
        url: `/v1/dashboard/all-metrics`,
        method: "GET",

        params: {
          start,
          end,
        },
      }),
      providesTags: ["esg-module"],
    }),
    uploadFile: builder.mutation({
      query: ({ file, project_id, company_id }) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("project_id", project_id);
        formData.append("company_id", company_id);

        return {
          url: `/v1/upload-file`,
          method: "POST",
          body: formData,
          formData: true,
        };
      },
      invalidatesTags: ["esg-module"],
    }),

    getenvironmentMetricsList: builder.query({
      query: () => {
        return {
          url: `/v1/dashboard/environmental`,
          method: "GET",
        };
      },
      providesTags: ["esg-module"],
    }),
    // /v1/dashboard/environmental'
    getorganisationMetricsList: builder.query({
      query: (nodeID) => {
        return {
          url: `/v1/hierarchical-metrics/${nodeID}`,
          method: "GET",
        };
      },
      providesTags: ["esg-module"],
    }),
    getmetricsstatus: builder.query({
      query: ({ metric_id, company_id, start_date, end_date }) => {
        const params = { metric_id };

        if (company_id) params.company_id = company_id;
        if (start_date) params.start_date = start_date;
        if (end_date) params.end_date = end_date;

        return {
          url: "/v1/metrics-status",
          method: "GET",
          params,
        };
      },
      providesTags: ["esg-module"],
    }),

    submitGriResponses: builder.mutation({
      query: (payload) => ({
        url: `/v1/gri/responses`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["esg-module"],
    }),
    submitPocAssignments: builder.mutation({
      query: (payload) => {
        console.log("  Payload:", payload);

        return {
          url: "/v1/poc_assignments",
          method: "POST",
          body: payload,
        };
      },
      invalidatesTags: ["esg-module"],
    }),

    getPocAssignments: builder.query({
      query: ({ company_id }) => {
        const params = { company_id };

        return {
          url: "/v1/get_poc_assignments",
          method: "GET",
          params,
        };
      },
      providesTags: ["esg-module"],
    }),

    getGriFormResponses: builder.query({
      query: ({ project_id }) => ({
        url: `/v1/gri/form_responses?project_id=${project_id}`,
        method: "GET",
      }),
      providesTags: ["esg-module"],
    }),

    // /v1/metrics/details/9/E_005/512
    getmetricssubmitteddetails: builder.query({
      query: ({ projectId, metric_id, nodeId }) => {
        return {
          url: `/v1/metrics/details/${metric_id}`,
          method: "GET",
        };
      },
      providesTags: ["esg-module"],
    }),

    getstandardsList: builder.query({
      query: () => {
        return {
          url: `/v1/standards`,
          method: "GET",
        };
      },
      providesTags: ["esg-module"],
    }),
    getcategoryList: builder.query({
      query: () => {
        return {
          url: `/v1/categories`,
          method: "GET",
        };
      },
      providesTags: ["esg-module"],
    }),
    getFormList: builder.query({
      query: (report_id) => {
        return {
          url: `/v1/details/${report_id}`,
          method: "GET",
        };
      },
      providesTags: ["esg-module"],
    }),

    getalldocuments: builder.query({
      query: (report_id) => {
        return {
          url: `/v1/documents/all/`,
          method: "GET",
        };
      },
      providesTags: ["esg-module"],
    }),

    AddMetricsList: builder.mutation({
      query: (metricsData) => ({
        url: "/v1/metric-master/",
        method: "POST",
        body: metricsData,
      }),
      invalidatesTags: ["esg-module"],
    }),

    Getprojectidlist: builder.query({
      // call like:
      // useGetprojectidlistQuery({ companyId: 82, start_date, end_date })
      query: ({ companyId, start_date, end_date }) => {
        const params = { company_id: companyId };

        if (start_date) params.start_date = start_date;
        if (end_date) params.end_date = end_date;

        return {
          url: "v1/metrics",
          method: "GET",
          params, // → /v1/metrics?company_id=82&start_date=2024-01-01&end_date=2024-12-31
        };
      },
      providesTags: ["esg-module"],
    }),

    Getunits: builder.query({
      query: () => {
        return {
          url: `/v1/units/`,
          method: "GET",
        };
      },
      providesTags: ["esg-module"],
    }),

    getRequestList: builder.query({
      query: () => {
        return {
          url: `/v1/debug/form-tokens-with-reports`,
          method: "GET",
        };
      },
      providesTags: ["esg-module"],
    }),
    getsubmittedBaseMetricsList: builder.query({
      query: (metric_id) => {
        return {
          url: `/v1/submit-data/${metric_id}`,
          method: "GET",
        };
      },
      providesTags: ["esg-module"],
    }),
    configmetricList: builder.mutation({
      query: ({ metric_id, operations = [], metric_status = "active" }) => ({
        url: `/v1/metric-master/${metric_id}/fields`,
        method: "POST",
        body: {
          operations,
          metric_status,
        },
      }),
      invalidatesTags: ["esg-module"],
    }),

    submitBaseMetrics: builder.mutation({
      query: (payload) => ({
        url: `/v1/submit-data`,
        method: "POST",
        body: payload,
        formData: true,
      }),
      invalidatesTags: ["esg-module"],
    }),

    submitrequestemailMetrics: builder.mutation({
      query: (payload) => ({
        url: `/v1/send_form_link`,
        method: "POST",
        body: payload,
      }),
      providesTags: ["esg-module"],
    }),
    requestemailMetrics: builder.query({
      query: (id) => {
        return {
          url: `/v1/form/${id}/metrics`,
          method: "GET",
        };
      },
      providesTags: ["esg-module"],
    }),

    getdocumentsMetrics: builder.query({
      query: (id) => {
        return {
          url: `/v1/documents/metric/${id}`,
          method: "GET",
        };
      },
      providesTags: ["esg-module"],
    }),

    submitFormMetrics: builder.mutation({
      query: ({ id, payload }) => {
        return {
          url: `/v1/form/${id}/submit-with-files`,
          method: "POST",
          body: payload,
        };
      },
      invalidatesTags: ["esg-module"],
    }),

    submitApprove: builder.mutation({
      // body must be: { approve_ids: [], reject_ids: [], comment: "" }
      query: ({ report_id, approve_ids, reject_ids, comment }) => ({
        url: `/v1/approve/${report_id}`,
        method: "POST",
        body: {
          approve_ids,
          reject_ids,
          comment: (comment || "").trim() || "No comment",
        },
      }),
      invalidatesTags: ["esg-module"],
    }),
    rejectApprove: builder.mutation({
      query: ({ report_id, comment }) => ({
        url: `/v1/reports/${report_id}/reject`,
        method: "POST",
        body: { comment },
      }),
      invalidatesTags: ["esg-module"],
    }),

    grimetricdata: builder.query({
      query: ({ project_id }) => ({
        url: `/v1/gri/form-structure?project_id=${project_id}`,
        method: "GET",
      }),
      providesTags: ["esg-module"],
    }),

    getProjects: builder.query({
      query: () => {
        return {
          url: `/v1/projects/`,
          method: "GET",
        };
      },
      providesTags: ["esg-module"],
    }),
    getCategoryDashboardData: builder.query({
      query: ({ node, start_date, end_date }) => ({
        url: `/v1/dashboard/category`,
        method: "GET",

        params: {
          start_date: start_date, // Dynamic start date
          end_date: end_date, // Dynamic end date
          company_id: node, // Dynamic node (Business Unit or Taxonomy)
        },
      }),
      providesTags: ["esg-module"],
    }),

    createProject: builder.mutation({
      query: (payload) => ({
        url: `/v1/projects`,
        method: "POST",
        body: payload,
      }),
      providesTags: ["esg-module"],
    }),

    Projectdownload: builder.mutation({
      query: ({ projectId, email }) => {
        const formData = new FormData();
        formData.append("user_email", email);
        formData.append("format", "excel");

        return {
          url: `/v1/export`,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: ["esg-module"],
    }),
    processSheetsAndColumns: builder.mutation({
      query: (payload) => ({
        url: `/v1/process-sheets-and-columns`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["esg-module"],
    }),
    processAndSubmitExcel: builder.mutation({
      query: (payload) => ({
        url: "/v1/process-and-submit-excel",
        method: "POST",
        body: payload,
      }),
    }),

    getMatchingInterface: builder.query({
      query: (session_id) => ({
        url: `/v1/matching-interface/${session_id}`,
        method: "GET",
      }),
      providesTags: ["esg-module"],
    }),

    getdashboardallmetricList: builder.query({
      query: ({ node, start_date, end_date }) => ({
        url: `/v1/dashboard/all-metrics`,
        method: "GET",

        params: {
          start_date: start_date || null,
          end_date: end_date || null,
          company_id: node || null,
        },
      }),
      providesTags: ["esg-module"],
    }),

    GetBenchmarkingData: builder.query({
      query: (args) => {
        const companies = args?.companies?.length
          ? args.companies.join(",")
          : undefined;
        return {
          url: `/v1/benchmarking`,
          method: "GET",

          params: companies ? { companies } : undefined,
        };
      },
    }),

    getProjectData: builder.query({
      query: (projectId) => ({
        url: `/v1/data`,
        method: "GET",
      }),
      providesTags: ["esg-module"],
    }),
    getMetricDataCollectionLevel: builder.query({
      query: (id) => ({
        url: `/v1/metric-master/data_collection_level/${id}`,
        method: "GET",
      }),
      providesTags: ["esg-module"],
    }),
    submitteremailMetrics: builder.query({
      query: (id) => ({
        url: `/v1/form/${id}/metrics`,
        method: "GET",
      }),
      providesTags: ["esg-module"],
    }),

    submitFormWithFiles: builder.mutation({
      query: ({ id, formData }) => ({
        url: `/v1/form/${id}/submit-with-files`,
        method: "POST",
        body: formData,
        formData: true,
      }),
      invalidatesTags: ["esg-module"],
    }),
    getMyForms: builder.query({
      query: (params = {}) => ({
        url: `/v1/my-forms`,
        method: "GET",
        params,
      }),
      providesTags: ["esg-module"],
    }),

    getPendingApprovals: builder.query({
      query: () => ({
        url: `/v1/pending-approvals`,
        method: "GET",
      }),
      providesTags: ["esg-module"],
    }),
    getFormApproval: builder.query({
      query: (formId) => ({
        url: `/v1/approve/${formId}`, // The dynamic form ID will be passed
        method: "GET", // Using GET method
      }),
      providesTags: ["esg-module"],
    }),
    getAllFormsTracking: builder.query({
      query: () => ({
        url: "/v1/all-forms-tracking",
        method: "GET",
      }),
      providesTags: ["esg-module"],
    }),
    sendMultipleFormLinks: builder.mutation({
      query: (payload) => ({
        url: `/v1/send_multiple_form_links`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["esg-module"],
    }),
    getMetricWiseMetrics: builder.query({
      query: () => ({
        url: `/v1/metric-wise/metrics`,
        method: "GET",
      }),
      providesTags: ["esg-module"],
    }),
    // AFTER
    getCompanyMetrics: builder.query({
      // Accept company_id and period from the caller
      query: ({ metric_ids, company_id, period }) => ({
        url: `/v1/metric-wise/company-metrics`,
        method: "GET",
        params: {
          company_id,
          period,
          metric_ids:
            Array.isArray(metric_ids) && metric_ids.length
              ? metric_ids.join(",")
              : undefined,
        },
      }),
      providesTags: ["esg-module"],
    }),

    metricSuggestions: builder.mutation({
      query: (payload) => ({
        url: "/v1/metric-suggestions",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["esg-module"],
    }),

    bulkCreateUnits: builder.mutation({
      query: (data) => ({
        url: "/v1/bulk/units/",
        method: "POST",
        body: data,
      }),
    }),

    getFormApprovalStatus: builder.query({
      query: (formId) => ({
        url: `/v1/form/${formId}/approval-status`,
        method: "GET",
      }),
      providesTags: ["esg-module"],
    }),

    exportBRSRToEmail: builder.mutation({
      query: ({ user_email }) => {
        const formBody = new URLSearchParams();
        formBody.append("user_email", user_email);

        return {
          url: `/v1/brsr-data-summary`,
          method: "POST",
          body: formBody.toString(),
        };
      },
    }),

    getCompanyComparison: builder.query({
      query: ({ company_ids, start_date, end_date }) => ({
        url: `/v1/dashboard/company-comparison`,
        method: "GET",

        params: {
          company_ids: company_ids.join(","),
          start_date,
          end_date,
        },
      }),
      providesTags: ["esg-module"],
    }),
  }),
});

export const {
  useGetMetricWiseMetricsQuery,
  useGetAllFormsTrackingQuery,
  useSendMultipleFormLinksMutation,
  useGetPendingApprovalsQuery,
  useSubmitFormWithFilesMutation,
  useGetFormApprovalQuery,
  useGetBaseMetricsListQuery,
  useGetMyFormsQuery,
  useGetdashboardallmetricListQuery,
  useGetProjectDataQuery,
  useGetBenchmarkingDataQuery,
  useUploadFileMutation,
  useGetstandardsListQuery,
  useGetcategoryListQuery,
  useSubmitteremailMetricsQuery,
  useGetFormListQuery,
  useGetMetricDataCollectionLevelQuery,
  useProcessSheetsAndColumnsMutation,
  useSubmitPocAssignmentsMutation,
  useGetMatchingInterfaceQuery,
  useGetRequestListQuery,
  useGetorganisationMetricsListQuery,
  useProcessAndSubmitExcelMutation,
  useSubmitApproveMutation,
  useConfigmetricListMutation,
  useRejectApproveMutation,
  useAddMetricsListMutation,
  useGetsubmittedBaseMetricsListQuery,
  useSubmitBaseMetricsMutation,
  useGetunitsQuery,
  useGetmetricsstatusQuery,
  useGetprojectidlistQuery,
  useLazyGetMatchingInterfaceQuery,
  useSubmitFormMetricsMutation,
  useGetCategoryDashboardDataQuery,
  useGetGriFormResponsesQuery,
  useProjectdownloadMutation,
  useGrimetricdataQuery,
  useGetdocumentsMetricsQuery,
  useSubmitGriResponsesMutation,
  useGetenvironmentMetricsListQuery,
  useGetalldocumentsQuery,
  useLazyGetPocAssignmentsQuery,
  useGetPocAssignmentsQuery,
  useGetmetricssubmitteddetailsQuery,
  useSubmitrequestemailMetricsMutation,
  useRequestemailMetricsQuery,
  useMetricSuggestionsMutation,
  useExportBRSRToEmailMutation,

  useGetdashboardListQuery,
  useGetProjectsQuery,
  useBulkCreateUnitsMutation,
  useCreateProjectMutation,
  useGetFormApprovalStatusQuery,
  useGetCompanyComparisonQuery,
  useGetCompanyMetricsQuery,
} = esgmoduleactivites;
